import { Component, ChangeDetectionStrategy } from '@angular/core'
import { takeUntilDestroyed } from '@angular/core/rxjs-interop'
import { FormsModule } from '@angular/forms'
import { RouterOutlet } from '@angular/router'
import { reloginIfRequired$ } from '@saniup-webapps/shared'

@Component({
  selector: 'app-root',
  imports: [RouterOutlet, FormsModule],
  templateUrl: './app.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  styleUrl: './app.component.scss',
})
export class AppComponent {
  private readonly _ = reloginIfRequired$().pipe(takeUntilDestroyed()).subscribe()
}
